import { ListOverlay, Row } from './ListOverlay.js';
import { diaHora } from '../lib/fechas.js';
import type { SessionState } from '../lib/session.js';
import { navigate } from '../lib/hash-route.js';
import { etiquetaEstadoMensaje } from '../lib/etiquetas-metricas.js';
import { rotuloPeriodo } from '../lib/snapshot-types.js';

interface WaRow {
  id: string; ghl_message_id: string | null; user_email: string | null;
  persona?: string;
  contact_id: string | null; body: string | null;
  direction: string | null; status: string | null;
  replied: boolean | null;
  clase?: string;
  created_at: string;
}

interface Props {
  session: SessionState;
  scope: 'me' | 'team';
  /** El filtro que aplico el snapshot: la lista son los mismos mensajes que suma la tarjeta. */
  filtro: URLSearchParams;
  locationId: string | null;
  filter: 'all' | 'replied';
}

/** La fecha de una fila: «mié 7 oct, 19:34» (el formato de toda la app, lib/fechas.ts). */
const cuando = (iso: string): string => diaHora(iso);

/** Los WhatsApp enviados que cuentan (sin SMS ni recordatorios del sistema). */
export function WhatsAppList({ session, scope, filtro, locationId, filter }: Props) {
  const q = new URLSearchParams(filtro);
  q.set('max', '500');
  if (filter === 'replied') q.set('replied', '1');
  const path = `/api/dashboard/whatsapp?${q.toString()}`;
  const desde = filtro.get('desde') ?? filtro.get('from');
  const hasta = filtro.get('hasta') ?? filtro.get('to');
  return (
    <ListOverlay<WaRow>
      session={session}
      title={filter === 'replied' ? 'WhatsApp · respondieron' : 'WhatsApp enviados'}
      subtitle={
        <FilterTabs
          current={filter}
          onChange={(f) => navigate({ kind: 'whatsapp-list', scope, filter: f })}
          periodo={desde && hasta ? rotuloPeriodo(desde, hasta) : ''}
        />
      }
      fetchPath={path}
      itemsKey="messages"
      emptyMessage={filter === 'replied' ? 'Nadie ha contestado a los WhatsApp de este periodo.' : 'Sin WhatsApp enviados en este periodo.'}
      onItemClick={(m) => {
        if (locationId && m.contact_id) {
          window.open(`https://app.gohighlevel.com/v2/location/${locationId}/contacts/detail/${m.contact_id}`, '_blank', 'noopener');
        }
      }}
      renderRow={(m) => (
        <Row
          left={<>
            <div className="row-title" style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
              {m.status ? <span style={{ fontSize: 10, padding: '1px 5px', borderRadius: 3, background: 'var(--surface-hi)', color: 'var(--fg-muted)' }}>{etiquetaEstadoMensaje(m.status)}</span> : null}
              {m.replied && <span style={{ fontSize: 10, padding: '1px 5px', borderRadius: 3, background: 'var(--ok-soft)', color: 'var(--ok)' }}>respondió</span>}
            </div>
            <div className="row-sub" style={{ color: 'var(--fg)' }}>{(m.body ?? '').slice(0, 220)}</div>
          </>}
          aside={<>
            <div>{m.persona ?? m.user_email ?? 'Sin asignar'}</div>
            <div>{cuando(m.created_at)}</div>
          </>}
        />
      )}
    />
  );
}

function FilterTabs({ current, onChange, periodo }: { current: 'all' | 'replied'; onChange: (f: 'all' | 'replied') => void; periodo: string }) {
  return (
    <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 8, flexWrap: 'wrap' }}>
      <button className={`tab${current === 'all' ? ' active' : ''}`} onClick={() => onChange('all')}>Todos</button>
      <button className={`tab${current === 'replied' ? ' active' : ''}`} onClick={() => onChange('replied')}>Respondieron</button>
      {periodo && <span style={{ color: 'var(--fg-subtle)', fontSize: 11 }}>· {periodo}</span>}
    </div>
  );
}
